// extracted by mini-css-extract-plugin
export default {"mCard":"ME-z","image":"NE-z","imageNoBackground":"OE-z","imageHasCategory":"PE-z","fullWidth":"QE-z"};